import { Box } from "@mui/material";

import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';

import { useNavigate } from "react-router-dom";

import PageHero from "../../components/motion/PageHero";

import CertificateVerifyPanel from "../../components/certificates/CertificateVerifyPanel";

import { useConstants } from "../../hooks/UseConstants";

import { Button } from "@mui/material";



function CertificateVerify() {

    const { language } = useConstants();

    const isAr = language === 'ar';

    const navigate = useNavigate();



    return (

        <Box sx={{ maxWidth: 640, mx: 'auto' }}>

            <PageHero

                title={isAr ? 'التحقق من الشهادة' : 'Verify certificate'}

                subtitle={isAr

                    ? 'أدخل رمز التحقق من الشهادة أو امسح رمز QR — نفس الرمز الموجود في صفحة شهاداتك'

                    : 'Enter the certificate verification code or scan the QR — the same code shown on your certificates page'}

                icon={<VerifiedOutlinedIcon />}

                actions={

                    <Button

                        variant="outlined"

                        onClick={() => navigate('/certificates')}

                        sx={{ bgcolor: 'rgba(255,255,255,0.9)', color: '#0D358C', fontWeight: 700 }}

                    >

                        {isAr ? 'شهاداتي' : 'My certificates'}

                    </Button>

                }

            />

            <CertificateVerifyPanel />

        </Box>

    );

}



export default CertificateVerify;

